// In-memory, by-id cache used to keep the synchronous accessors that
// several pages rely on (e.g. `vehicleService.byId`, `tripService.forVehicle`)
// working against a real HTTP backend.
//
// The old mock service could offer synchronous lookups because its "data"
// was just a static in-memory array. A real backend has no synchronous
// equivalent, so instead every async `list()`/`get()` call warms one of
// these caches, and the synchronous accessors read whatever is currently
// warm. See `warmCoreCaches()` in services/api.js for how the caches are
// pre-populated on login/app-load so the first render of a page already
// has data to read.
export function createCache() {
  const store = new Map();

  const cache = {
    put(item) {
      if (item && item.id != null) store.set(item.id, item);
      return item;
    },
    warm(items) {
      (items || []).forEach((item) => cache.put(item));
      return items;
    },
    get(id) {
      return id == null ? undefined : store.get(id);
    },
    all() {
      return Array.from(store.values());
    },
    filter(predicate) {
      return Array.from(store.values()).filter(predicate);
    },
    clear() {
      store.clear();
    },
  };
  return cache;
}
